import React, { useEffect, useState } from "react";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { useAdminReport } from "./AdminReport_hook/useAdminRepo";
import { useGetOrgUnitsData } from "../FSM/Beats_Patches/hooks/useBeat";
import { useGetMothYearFiler } from "./Employee_hook/useEmployee";
import { getAdminReport } from "./AdminReport_hook/AdminRepo";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import { showToast } from "../../utils/toastUtils";
import { COLORS } from "../../constants/colors";

type Props = {};

function AdminReports({}: Props) {
  const { startPolling,stopPolling } = useExcelPolling();
  const [isOpenModal, setIsModalOpen] = useState(false);
  const [excelLoading, setExcelLoading] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading.");
  const { data: orgUnitsList } = useGetOrgUnitsData({ enable: true });
  const [filter, setFilter] = useState({
    action: "view",
    page: 1,
    limit: 10,
    OrgUnit: "",
    // month: "2025-05",  // pending this formate form backend-side
    month: "",
  });

  const {
    data: monthData,
    isLoading: monthData_isLoading,
    isSuccess: monthData_IsSuccess,
  } = useGetMothYearFiler({ enable: true });

  const {
    data: adminReportData,
    isLoading: adminReportData_isLoading,
    isSuccess: adminReportData_isSuccess,
  } = useAdminReport({
    param: {
      action: filter.action,
      page: 1,
      limit: filter.limit,
      month: filter.month,
      orgUnitId: filter.OrgUnit,
    },
    enable: !!filter.OrgUnit && !!filter.month,
  });

  const rowData = monthData?.rowData.data;
  const formatedData = Object.entries(rowData?.MonthYear || {}).map(
    ([key, value]) => ({
      id: key,
      label: value,
    })
  );

  const handleDownload = async () => {
    if (filter.month !== "" && filter.OrgUnit !== "") {
      const param = {
        action: "download",
        page: 1,
        limit: filter.limit,
        month: filter.month,
        orgUnitId: filter.OrgUnit,
      };
      const response = await getAdminReport(param);
      const { success, fileDownloadId, intervalTime } = response?.rowData?.data || {};

      if (success && fileDownloadId) {  
        try {
          setExcelLoading(true);
          startPolling(fileDownloadId, intervalTime, {
            onStatusUpdate: (currentStatus: string) => {
              setExcelStatus(currentStatus);
            },
            onSuccess: (url: string) => {
              setExcelLoading(false);
              setExcelStatus("Loading..")
              const a = document.createElement("a");
              a.href = url;
              a.download = "report.xlsx";
              a.click();
              showToast.success("The file is ready!");
            },
            onFailed: (message: string) =>{
              showToast.error(message || "OnFailed on Admin excel report")
            stopPolling();
            setExcelLoading(false);
            },
            onExpired: (message: string) =>{
              showToast.error(message || "OnExpired on Admin excel report")
              stopPolling();
              setExcelLoading(false);
            },
            onDelete: (message: string) =>{
              showToast.error(message || "onDelete on Admin excel report")
              stopPolling();
             setExcelLoading(false);
            }
          });
        } catch (error: any) {
          console.log("Error while downloading excel in Admin report");
        }
      } 
    }else{
        showToast.info("Select mandatory filter");
    }
  };

  const handlePagination = (pageNO: any) => {
    setFilter((prev: any) => ({
      ...prev,
      page: pageNO,
    }));
  };

  const handleonChangeRowsPerPage = (newPerPage: any, page: any) => {
    setFilter((prev: any) => ({
      ...prev,
      page: page,
      limit: newPerPage,
    }));
  };

  return (
    <div className="p-2">
      <PageHeader
        title="Admin Reports"
        buttons={[
          {
            label:excelLoading?excelStatus?excelStatus.charAt(0).toLocaleUpperCase() + excelStatus.slice(1) +'...':"":"Excel",
            onClick: () => handleDownload(),
            color: excelLoading?COLORS.disable:COLORS.primary,
             disable:excelLoading?true:false
          },
        ]}
      />

      {/* Table with Filters */}
      <BasicDataTable
        search={false}
        Title="Admin Reports"
        filterFirstApporach={!!filter.OrgUnit && !!filter.month} // it should be || condition
        data={
          (!adminReportData_isLoading &&
            adminReportData_isSuccess &&
            adminReportData?.formatedData) ||
          []
        }
        showSpinner={adminReportData_isLoading}
        columns={leaveRequestColumns()}
        headerContent={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "10px",
              marginBottom: "15px",
            }}
          >
            {/* Month Dropdown */}
            <RoundedDropdown
              options={formatedData || []}
              onSelect={(e: any) =>
                setFilter((prev: any) => ({ ...prev, month: e.id }))
              }
              defaultLabel="All"
              width="120px"
              isShowHeading
              DropdownHeading="Month"
              headingColor="#2e8dd3"
            />
            <RoundedDropdown
              options={orgUnitsList?.data || []}
              onSelect={(e: any) =>
                setFilter((prev: any) => ({ ...prev, OrgUnit: e.id }))
              }
              defaultLabel="All"
              width="120px"
              isShowHeading
              DropdownHeading="Division"
              headingColor="#2e8dd3"
            />
          </div>
        }
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        paginationTotalRows={
          adminReportData?.rowData.data.Pagination.TotalCounts || 0
        }
      />
    </div>
  );
}

export default AdminReports;

const leaveRequestColumns = () => [
  {
    name: "Employee Name",
    selector: (row: { EmployeeName: string }) =>
      row.EmployeeName ? row.EmployeeName : "-",
    sortable: true,
    width: "200px",
    wrap: true,
  },
  {
    name: "Designation",
    selector: (row: { Designation: string }) => row.Designation ?? "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
  {
    name: "Head Quarter Location",
    selector: (row: { Branch: string }) => row.Branch ?? "-",
    sortable: true,
    width: "240px",
    wrap: true,
  },
  {
    name: "Created",
    selector: (row: { Created: string }) => row.Created || "-",
    sortable: true,
    width: "150px",
  },
  {
    name: "Submitted",
    selector: (row: { Submited: string }) =>
      row.Submited === "0" ? "0" : row.Submited,
    sortable: true,
    width: "150px",
  },
  {
    name: "Approved",
    selector: (row: { Approved: string }) =>
      row.Approved === "0" ? "0" : row.Approved,
    sortable: true,
    width: "150px",
  },
  {
    name: "Rejected",
    selector: (row: { Rejected: string }) =>
      row.Rejected === "0" ? "0" : row.Rejected,
    sortable: true,
    width: "150px",
  },
  {
    name: "Processed",
    selector: (row: { Audited: string }) =>
      row.Audited === "0" ? "0" : row.Audited,
    sortable: true,
    width: "150px",
  },
];
